import type { FaireProductEntity } from "../../entity_types/product";

export const p_8ffyn8sqxs: FaireProductEntity = {
  token: "p_8ffyn8sqxs",
  type: "product",
  name: "Boho Print Wide-Leg Casual Pants",
  brandToken: "b_q6uy7uqavt",
  brandName: "Soli Echo",
  imageUrl:
    "https://cdn.faire.com/fastly/cc225780e5bb82e3c4c04e9908f3f9819b37a41af899f1a35effd73bb144e7da.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8299cb45fb3402fa8b3653e74364d03b9b8043f9c7d567b14cf09b02b4be78bf.jpeg",
    "https://cdn.faire.com/fastly/70432a5c93a4ce719939a0b7cc1902dad18344cecbdd41dc847e759adced5a17.jpeg",
    "https://cdn.faire.com/fastly/ca5e409fab892a8f365c27e9f168d283741d2b5cd8876c573d48c0a2185a7289.jpeg",
    "https://cdn.faire.com/fastly/1fd3779e3c7785aa3fea10df41335ba696019c4c66c0209a144a24ef9c802dae.jpeg",
  ],
  priceDollars: 23.12,
  description:
    "Bohemian, flowy, and chic—perfect for breezy weekends.\n\nFabric: 100% polyester\n\nWeight: 0.77 lb\n",
  tags: [],
  msrpDollars: 46.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:54.795Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
